<script setup lang="ts">
defineProps<{ types: any }>();

const { t } = useI18n();
</script>

<template>
  <div class="types-mobile">
    <div v-for="type in types" :key="type.id" class="types-mobile__item">
      <div class="types-mobile__item-inner">
        <p class="types-mobile__item-title">
          <Component :is="type.icon" />
          {{ $t(type.nameKey) }}
        </p>
        <p class="types-mobile__item-desc">
          {{ type.ips }} {{ $t('pages.home.types.from') }} {{ type.price }}
        </p>
        <p class="types-mobile__item-desc">
          {{ $t(type.descriptionKey) }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.types-mobile {
  padding-inline: 2rem;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 400px;
  &__item {
    &:not(:last-child) {
      padding-bottom: 16px;
      border-bottom: var(--border-sx-main);
      border-radius: 0;
    }
    &-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      text-align: center;
    }
    &-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 720;
      font-size: 20px;
      line-height: 24px;
      letter-spacing: -3%;
    }
    &-desc {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0;
    }
  }
}
</style>